import { render, staticRenderFns } from "./actualList.vue?vue&type=template&id=02806d3f&scoped=true"
import script from "./actualList.vue?vue&type=script&lang=js"
export * from "./actualList.vue?vue&type=script&lang=js"
import style0 from "./actualList.vue?vue&type=style&index=0&id=02806d3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02806d3f",
  null
  
)

export default component.exports